module.exports = __webpack_public_path__ + "img/qrcode.adb831a1.jpg";